import { DragOverlay } from "@dnd-kit/core"
import { FunctionComponent } from "react"

type DragOverlayProps = {
  children: React.ReactNode
}

const DragOverlayArea: FunctionComponent<DragOverlayProps> = ({ children }) => {
  return (
    <DragOverlay dropAnimation={null}>
      <div className="bg-white border-4 border-solid border-blue-500 rounded-xl shadow-lg  z-50 p-2 opacity-90 cursor-grabbing w-full h-full">
        {children}
      </div>
    </DragOverlay>
  )
}

export default DragOverlayArea
